import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Select from '../../Shared/UI/Select/components/Select';
import Textarea from '../../Shared/UI/Textarea/components/Textarea';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { useProfileState, useProfileActions } from './ProfileContext';

import { createUserEducation } from './restApi';

import educationDegreeTypeOptions from './educationDegreeTypeOptions';

const NewUserEducationForm = () => {
  const profileState = useProfileState();
  const { onResponse, onError, updateNewUserEducationFormInstitution, updateNewUserEducationFormDegreeType, updateNewUserEducationFormFieldOfStudy, updateNewUserEducationFormGraduationYear, updateNewUserEducationFormDescription, closeNewUserEducationModal } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    createUserEducation({
      onResponse,
      onError,
      body: {
        authenticityToken,
        newUserEducationForm: profileState?.newUserEducationForm,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Institution" id="institution">
        <Input
          type="text"
          value={profileState?.newUserEducationForm?.institution || ''}
          onChange={(e) => {
            updateNewUserEducationFormInstitution(e.target.value);
          }}
        />
      </Field>

      <Field label="Degree Type" id="degreeType">
        <Select
          value={profileState?.newUserEducationForm?.degreeType || ''}
          onChange={(e) => {
            updateNewUserEducationFormDegreeType(e.target.value);
          }}
        >
          <option value=""></option>
          {educationDegreeTypeOptions.map((option) => (
            <option key={option.value} value={option.value}>{option.displayValue}</option>
          ))}
        </Select>
      </Field>

      <Field label="Field of Study" id="fieldOfStudy">
        <Input
          type="text"
          value={profileState?.newUserEducationForm?.fieldOfStudy || ''}
          onChange={(e) => {
            updateNewUserEducationFormFieldOfStudy(e.target.value);
          }}
        />
      </Field>

      <Field label="Graduation Year" id="graduationYear">
        <Select
          value={profileState?.newUserEducationForm?.graduationYear || ''}
          onChange={(e) => {
            updateNewUserEducationFormGraduationYear(e.target.value);
          }}
        >
          {(profileState?.userEducationGraduationYearOptions || []).map((option) => (
            <option key={option.value} value={option.value}>{option.displayValue}</option>
          ))}
        </Select>
      </Field>

      <Field label="Description" id="description">
        <Textarea
          value={profileState?.newUserEducationForm?.description || ''}
          onChange={(e) => {
            updateNewUserEducationFormDescription(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeNewUserEducationModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Save Your Education
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default NewUserEducationForm;
